export default __webpack_public_path__ + "static/LAURA_2_BW_web-28df7fb8620e35a7a03f4c13e92d22bd.jpg";